import React from 'react';

const ErrorLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className="col-span-6 px-2 py-4 sm:px-4 sm:py-4">{children}</div>;
};

export default ErrorLayout;
